/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useEffect } from "react"
import { Container, FlexContainer, H2, Stack } from "@carrotfertility/carotene"
import { Body } from "components/views/atoms/Bodies"
import { Button } from "components/views/atoms/buttons/Button"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import { IlloUnderwaterDesktop } from "components/views/atoms/Illustrations"
import { adminCarrotClient } from "utils/CarrotClient"
import { Modal } from "components/views/modal/Modal"
import useCarrotPlanEmployeeSettings from "./hooks/useCarrotPlanEmployeeSettings"
import { useCurrentUser } from "components/context/user/UserContext"
import { FormattedMessage, useIntl } from "react-intl"

export function CarrotPlanModal(): JSX.Element {
  const intl = useIntl()
  const { data, isLoading } = useCarrotPlanEmployeeSettings()
  const { showRegPreCarrotPlansSoftLaunchFeatures, isPosingAsMember } = useCurrentUser()
  const [show, setShow] = React.useState(false)
  useEffect(() => {
    if (showRegPreCarrotPlansSoftLaunchFeatures && !isLoading && data) {
      setShow(!data?.acknowledgedCarrotPlanPopupAt)
    }
  }, [data, isLoading, showRegPreCarrotPlansSoftLaunchFeatures])

  function handleExit(): void {
    setShow(false)
    if (!isPosingAsMember) {
      adminCarrotClient.setAcknowledgedCarrotPlansPopup()
    }
  }
  return (
    show && (
      <Modal
        onExit={handleExit}
        backgroundColor="warm-gray"
        titleText={intl.formatMessage({ defaultMessage: "Welcome to the new Carrot" })}
      >
        <Container paddingLeftRight="huge" alignItems="center">
          <FlexContainer justifyContent="center">
            <IlloUnderwaterDesktop className="" />
          </FlexContainer>
          <H2 stack="tiny">
            <FormattedMessage defaultMessage="Welcome to the new Carrot" />
          </H2>
          <Stack>
            <Body color="black-80">
              <FormattedMessage defaultMessage="We’ve designed a comprehensive benefit guide, deepened our library, and added more experts." />
            </Body>
            <Body color="black-80">
              <FormattedMessage
                defaultMessage="Now we invite you to get a Carrot Plan, personalized guidance that lets us support you better than ever,
              no matter where you are in your journey."
              />
            </Body>
          </Stack>
          <Stack paddingTopBottom="large" spacing="small" justifyContent="flex-end" direction="row">
            <Button onClickOnly onClick={handleExit} outline>
              <FormattedMessage defaultMessage="Skip for now" />
            </Button>
            <ButtonPrimary onClick={handleExit} to="/talk-to-carrot/get-your-carrot-plan">
              <FormattedMessage defaultMessage="Get your Carrot Plan" />
            </ButtonPrimary>
          </Stack>
        </Container>
      </Modal>
    )
  )
}
